import { render, staticRenderFns } from "./AdminTools.vue?vue&type=template&id=4f83ba0a&"
import script from "./AdminTools.vue?vue&type=script&lang=js&"
export * from "./AdminTools.vue?vue&type=script&lang=js&"
import style0 from "./AdminTools.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VApp,VBtn})
